import React from 'react';
import styled from 'styled-components';

const CenterAlignment = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  height: 90%;  
  justify-content: center;

  @media (max-width: 768px) {
    height: 100%;
  }
`;

/**
 * Center aligns children component(s) vertically and horizontally relative to parent container.
 */
const CenterAlign: React.FC = ({
  children
}) => {
  return (
    <CenterAlignment>
      {children}
    </CenterAlignment>
  )
}

export default CenterAlign;
